import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Dropdown } from "semantic-ui-react";
import cx from "classnames";
import * as currenciesActions from "../../actions/currenciesActions";
// import mockCurrencies from "./mock";
import { LAST_CURRENCY } from "../../constants/constants";
import styles from "./styles.less";

class CurrenciesDropdown extends Component {
  async componentDidMount() {
    const { actions, defaultCurrency } = this.props;
    await actions.getCurrenciesList();
    this.updateCurrencyIfNedded(actions.setCurrency, defaultCurrency);
  }

  componentDidUpdate(prevProps) {
    const { actions, defaultCurrency } = this.props;
    if (defaultCurrency !== prevProps.defaultCurrency) {
      if (defaultCurrency) {
        actions.setCurrency(defaultCurrency);
      }
    }
  }

  updateCurrencyIfNedded = (setCurrency, selectedCurrency) => {
    const serverSearchData = sessionStorage.getItem(LAST_CURRENCY);
    const currency = this.calcCurrency(serverSearchData, selectedCurrency);
    if (currency) {
      setCurrency(currency);
    }
  };

  calcCurrency = (SearchData, currency) => SearchData || currency;

  onCurrencyChange = async (e, { value }) => {
    const { actions } = this.props;
    await actions.setCurrency(value);
    sessionStorage.setItem(LAST_CURRENCY, value);
  };

  getDropdownValues = () => {
    const { selectedCurrency, currencies, isMobileView, titles } = this.props;

    const anySelectedCurrency = selectedCurrency !== "";
    let icon = "exchange";
    let text = titles.ConvertingCurrency;

    if (isMobileView) {
      text = "";
    }

    if (anySelectedCurrency) {
      const currency = currencies.find(
        c => c.currencyCode === selectedCurrency
      );
      icon = null;
      text = `${currency.symbol} - ${currency.currencyCode}`;
      if (isMobileView) {
        text = currency.symbol;
      }
    }

    return { text, icon };
  };

  toRender = () => {
    const { selectedCurrency, currencies, isMobileView } = this.props;
    const mainCurrencies = currencies.filter(c => c.main);
    const subCurrencies = currencies.filter(c => !c.main);
    const { text } = this.getDropdownValues();

    return (
      <div
        className={cx(styles.dropdownWrapper, {
          [styles.mobileView]: isMobileView
        })}
      >
        <Dropdown
          className={styles.dropdown}
          value={selectedCurrency}
          // icon={icon}
          text={text}
        >
          <Dropdown.Menu className={styles.dropdownMenu}>
            {mainCurrencies.map(c => (
              <Dropdown.Item
                value={c.currencyCode}
                text={`${c.symbol} - ${c.currencyCode}`}
                key={c.currencyCode}
                onClick={this.onCurrencyChange}
              />
            ))}
            <Dropdown.Divider />
            {subCurrencies.map(c => (
              <Dropdown.Item
                value={c.currencyCode}
                text={`${c.symbol} - ${c.currencyCode}`}
                key={c.currencyCode}
                onClick={this.onCurrencyChange}
              />
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  render() {
    const { currencies } = this.props;
    const isCurrenciesExist = currencies.length > 0;

    return isCurrenciesExist ? this.toRender() : <div />;
  }
}
CurrenciesDropdown.defaultProp = {
  currencies: [],
  isMobileView: false,
  titles: {},
  defaultCurrency: ""
};

CurrenciesDropdown.propTypes = {
  actions: PropTypes.object,
  selectedCurrency: PropTypes.string,
  currencies: PropTypes.array,
  isMobileView: PropTypes.bool,
  titles: PropTypes.object,
  defaultCurrency: PropTypes.string
};

function mapStateToProps(store) {
  return {
    selectedCurrency: store.selectedCurrency,
    currencies: store.currencies,
    isMobileView: store.isMobileView,
    titles: store.titles,
    defaultCurrency: store.hotelData.CurrencyCode
  };
}

function mapDispatchToProps(dispatch) {
  const combinedActions = {
    ...currenciesActions
  };
  return {
    actions: bindActionCreators(combinedActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CurrenciesDropdown);



// WEBPACK FOOTER //
// ./src/containers/CurrenciesDropdown/CurrenciesDropdown.js